import { useState } from "react";
import API from "../services/api";

export default function ExamMarks() {
  const [form, setForm] = useState({
    student_id: "",
    exam_type: "Quarterly",
    subject: "",
    marks_obtained: "",
    total_marks: "",
    exam_date: new Date().toISOString().split("T")[0]
  });

  const handleSubmit = async () => {
    try {
      await API.post("/exams/add", form);

      alert("Marks added successfully");

      setForm({
        student_id: "",
        exam_type: "Quarterly",
        subject: "",
        marks_obtained: "",
        total_marks: "",
        exam_date: new Date().toISOString().split("T")[0]
      });

    } catch (err) {
      alert("Failed to add marks");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Exam Marks Entry
      </h1>

      <div className="bg-white shadow p-6 rounded">

        <input
          placeholder="Student ID"
          value={form.student_id}
          onChange={(e) =>
            setForm({ ...form, student_id: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <select
          value={form.exam_type}
          onChange={(e) =>
            setForm({ ...form, exam_type: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        >
          <option>Unit Test</option>
          <option>Quarterly</option>
          <option>Half-Yearly</option>
          <option>Annual</option>
        </select>

        <input
          placeholder="Subject"
          value={form.subject}
          onChange={(e) =>
            setForm({ ...form, subject: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Marks Obtained"
          value={form.marks_obtained}
          onChange={(e) =>
            setForm({ ...form, marks_obtained: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Total Marks"
          value={form.total_marks}
          onChange={(e) =>
            setForm({ ...form, total_marks: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          type="date"
          value={form.exam_date}
          onChange={(e) =>
            setForm({ ...form, exam_date: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <button
          onClick={handleSubmit}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Save Marks
        </button>

      </div>
    </div>
  );
}